var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "form-page-detail" } },
    [
      _c(
        "div",
        {
          staticClass: "form-page-detail--header",
          class: { "form-page-detail--header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "8" } }, [
                _c("div", { staticClass: "name-data--header" }, [
                  _vm._v(_vm._s(_vm.form_data.name))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "id-data--header" }, [
                  _vm._v(_vm._s(_vm.form_data.id))
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "4" } }, [
                _c("i", {
                  staticClass:
                    "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__l--10 m__t--10",
                  attrs: { id: "configPopover" }
                })
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "form-page-detail--header_tab",
              attrs: { id: "form-header-tab" }
            },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "b-col",
                {
                  key: tab.id,
                  staticClass: "studio-page-tab",
                  class: {
                    "studio-page-tab-active": _vm.tabSelected === tab.id
                  },
                  on: {
                    click: function($event) {
                      _vm.selectTab(tab.id)
                    }
                  }
                },
                [
                  _c("h4", [_vm._v(_vm._s(tab.label))]),
                  _vm._v(" "),
                  _vm.tabSelected === tab.id
                    ? _c("div", { staticClass: "underline-data" })
                    : _vm._e()
                ]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-page-detail--body" },
        [
          _vm.tabSelected === "general"
            ? _c("j-form-general", {
                ref: "generalRef",
                attrs: { switcher: _vm.switcher }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "column" ? _c("j-form-column") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "data" ? _c("j-form-data") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "workflow"
            ? _c("j-form-workflow", { ref: "workflowRef" })
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "trigger" ? _c("j-form-trigger") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "exp_manager"
            ? _c("j-form-exp-manager")
            : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "log" ? _c("j-form-activity-log") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.closePopover,
              expression: "closePopover"
            }
          ],
          ref: "configPopoverRef",
          attrs: {
            show: _vm.configPopoverShow,
            target: "configPopover",
            placement: "leftbottom"
          },
          on: {
            "update:show": function($event) {
              _vm.configPopoverShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "add-automation", on: { click: _vm.openCodeForm } },
            [_vm._v("View Code")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBtnDeleteTable,
                  expression: "showBtnDeleteTable"
                }
              ],
              staticClass: "add-automation",
              on: { click: _vm.deleteFormData }
            },
            [_vm._v("Delete Table")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBtnTruncateTable,
                  expression: "showBtnTruncateTable"
                }
              ],
              staticClass: "add-automation",
              on: { click: _vm.truncateFormData }
            },
            [_vm._v("Truncate Data")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showBtnArchivePurgingData,
                  expression: "showBtnArchivePurgingData"
                }
              ]
            },
            [
              _c(
                "div",
                {
                  staticClass: "add-automation",
                  on: {
                    click: function($event) {
                      _vm.openArchivePurgingModal("archive")
                    }
                  }
                },
                [_vm._v("Archive Data")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "add-automation",
                  on: {
                    click: function($event) {
                      _vm.openArchivePurgingModal("purging")
                    }
                  }
                },
                [_vm._v("Purging Data")]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appCodeFormDataModal",
          staticClass: "mod-form modal-code-form-data",
          attrs: { centered: "" }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("VIEW CODE")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "btn-delete", on: { click: _vm.copyCode } },
            [
              _c("i", {
                staticClass: "fa fa-files-o font-weight-bold cursor-pointer"
              }),
              _vm._v(" Copy\n    ")
            ]
          ),
          _c("br"),
          _vm._v(" "),
          _vm.showCodeEditor
            ? _c("j-monaco-editor", {
                ref: "scriptEditor",
                staticClass: "m__t--10",
                attrs: { value: _vm.jsonData, language: "json" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("div", { staticStyle: { opacity: "0" } }, [
                  _c("textarea", {
                    attrs: { id: "view-code" },
                    domProps: { value: _vm.viewCode }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "6" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCodeForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("modal-archive-purging-data", {
        attrs: { mode: _vm.selectedMode },
        on: {
          close: function($event) {
            _vm.toggleArchivePurgingModal(true)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b45887a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b45887a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormPageDetail.vue
// module id = null
// module chunks = 